import { observer } from 'mobx-react-lite';
import { useEffect, useMemo } from 'react';

import { Table } from '@/components/table';
import { attachmentHistoryStore } from '@/stores';
import { getGenericFilters, toQueryFormat } from '@/components/table/utils';

import { columns } from './setup';

const store = attachmentHistoryStore;

export const AttachmentHistory = observer(() => {
  useEffect(() => {
    store.forceLoad({ sort: 'createdAt:-1' });
  }, []);

  const genericFilters = useMemo(() => getGenericFilters(columns), []);

  const onChangeTable = (...args: any[]) => {
    const params = toQueryFormat.apply(null, [genericFilters, ...args] as any);
    store.forceLoad(params);
  };

  return (
    <Table
      rowKey="id"
      columns={columns}
      dataSource={[...store.items]}
      store={store}
      loading={store.loading}
      scroll={{ x: 1200 }}
      onChange={onChangeTable}
    />
  );
});
